import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    childDialogs: [],
    confirmDialogs: [],
    dialogs: []
};
var dialogsSlice = createSlice({
    initialState: initialState,
    name: "dialogs",
    reducers: {
        pushDialog: function(state, param) {
            var payload = param.payload;
            if (payload.type === "confirm") {
                state.confirmDialogs.push(payload);
            } else if (payload.parent) {
                state.childDialogs.push(payload);
            } else {
                state.dialogs.push(payload);
            }
        },
        removeDialog: function(state, param) {
            var payload = param.payload;
            var predicate = function(param) {
                var id = param.id;
                return id !== payload;
            };
            var baseDialogs = state.dialogs.filter(predicate);
            if (state.dialogs.length !== baseDialogs.length) {
                state.dialogs = baseDialogs;
            } else {
                var baseChildDialogs = state.childDialogs.filter(predicate);
                if (state.childDialogs.length !== baseChildDialogs.length) {
                    state.childDialogs = baseChildDialogs;
                } else {
                    state.confirmDialogs = state.confirmDialogs.filter(predicate);
                }
            }
        },
        reset: function() {
            return initialState;
        }
    }
});
var _dialogsSlice_actions = dialogsSlice.actions;
export var pushDialog = _dialogsSlice_actions.pushDialog, removeDialog = _dialogsSlice_actions.removeDialog;
export var dialogsReducer = dialogsSlice.reducer;

//# sourceMappingURL=dialogs.js.map